import request from '../utils/request';
import { IResult } from '../global';

const imApi = {
  login: () => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: '/api/v2/im/login',
        method: 'get',
        credentials: 'include',
        headers: {
          Authorization: request.token
        }
      }).then(res => {
        if (!res.error) {
          resolve(res);
        } else {
          reject();
        }
      });
    });
  }
};

export default imApi;
